import * as React from "react";
const SvgMessagePlusCircle = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.965 11.5a7.465 7.465 0 1 0-14.541 2.386c.063.188.144.414.19.636l.032.218.008.17c0 .166-.02.321-.064.492-.07.275-.218.535-.324.73L3.84 18.77l4.679-.484c.122-.013.287-.031.449-.025.134.005.249.02.38.05.159.036.332.107.467.159a7.5 7.5 0 0 0 2.684.496 7.465 7.465 0 0 0 7.465-7.465m-8.5 3v-1.965H9.5a1.035 1.035 0 0 1 0-2.07h1.965V8.5a1.035 1.035 0 0 1 2.07 0v1.965H15.5a1.035 1.035 0 0 1 0 2.07h-1.966V14.5a1.035 1.035 0 1 1-2.07 0m10.57-3c0 5.266-4.27 9.535-9.535 9.535a9.5 9.5 0 0 1-3.428-.635l-.181-.069-.006-.002-.153.016-5.12.529c-.224.023-.463.049-.662.05-.187.003-.53-.007-.86-.208a1.54 1.54 0 0 1-.717-1.073c-.06-.381.061-.702.135-.874.078-.183.194-.394.3-.592l1.636-3.029c.07-.128.107-.198.132-.25l-.003-.011a11 11 0 0 0-.111-.34 9.5 9.5 0 0 1-.497-3.047 9.535 9.535 0 0 1 19.07 0"
}));
export default SvgMessagePlusCircle;
//# sourceMappingURL=MessagePlusCircle.js.map